<template>
  <div>
    <nav-title :color="false" :customClass="'bg-white h6'" :title="'Problem Solving'" />
    <div class="help-change-header border-bottom shadow-sm px-3 pt-2">
      <h6 class="help-header-title-color mb-1">
        <i class="material-icons align-middle smaller mr-1">
          playlist_add_check
        </i>
        To change what’s happening:
      </h6>
      <hr class="my-0" />
      <p class="py-3 pl-4">
        Select one or more of the following strategies:
      </p>
    </div>
  </div>
</template>
<script>
import navTitle from '@/components/general/navTitle.vue';
export default {
  components: {
    navTitle,
  },
};
</script>
<style lang="scss" scoped>
.help-header-title-color {
  color: var(--color-main);
}
</style>
